import {
  Card,
  Checkbox,
  CrudMode,
  DataDisplay,
  formatBoolean,
  Grid,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { LkRole, User, UserDto, UserEditResource, UserViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';

export const Texting = (props: {
  crudMode: CrudMode;
  userDto: UserDto;
  userMembership: string;
  reroute?: (userMembership: string, crudMode: CrudMode) => void;
  setUserDto: (value: UserDto) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
  selectedRole: LkRole | undefined;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const canConfigureAndUseTextingField = () => {
    var propertyName = pn<User>("canConfigureAndUseTexting");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.userDto.user!.canConfigureAndUseTexting)}</DataDisplay>
    ) : (
      <Checkbox
        label={property?.displayName}
        checked={props.userDto.user!.canConfigureAndUseTexting}
        onChange={(e) =>
          props.setUserDto(
            produce(props.userDto, (draft) => {
              draft.user!.canConfigureAndUseTexting = e.target.checked;
            })
          )
        }
      />
    );
  };

  const contactField = () => {
    var propertyName = pn<User>("contact");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.userDto.user!.contact}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.userDto.user!.contact}
        onChange={(e) =>
          props.setUserDto(
            produce(props.userDto, (draft) => {
              draft.user!.contact = e.target.value;
            })
          )
        }
      />
    );
  };

  const contactMethodField = () => {
    var propertyName = pn<User>("contactMethod");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.userDto.user!.contactMethod}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.userDto.user!.contactMethod}
        onChange={(e) =>
          props.setUserDto(
            produce(props.userDto, (draft) => {
              draft.user!.contactMethod = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Card transparentHeader={true} header={
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <PhoneAndroidOutlinedIcon></PhoneAndroidOutlinedIcon>
          <Typography variant="inherit" paddingLeft={"5px"}>Texting</Typography>
        </Stack>
      </Stack>
    } fullHeight>

      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {canConfigureAndUseTextingField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {contactField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {contactMethodField()}
        </Grid>
      </Grid>
    </Card>
  );
};
